// extracted by mini-css-extract-plugin
export default {"modal__content":"styles_modal__content__Jh+TN","modal":"styles_modal__7wntK","modal__btn":"styles_modal__btn__hB8Jf"};